export default "__VITE_ASSET__R179CFPj__"